import { KanbanQueueView, KanbanTaskView } from '@nexelem/graphne-api';

export const getExternalId = (task?: KanbanTaskView | KanbanQueueView) => (task?.externalId as { id?: number })?.id;
